import { Table } from "antd"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/pro-solid-svg-icons"
import { grey } from "@ant-design/colors"
import { InvoiceTotals, WorkareaGroupInvoiceSummary } from "./workareaTotalsModel"
import PricingTypeDisplay from "../../jobs/PricingTypeDisplay"

type Props = {
  groupTotals: WorkareaGroupInvoiceSummary[]
  invoiceTotals: InvoiceTotals
}

const WorkareaTotals = ({ groupTotals, invoiceTotals }: Props) => {
  const renderCheckOrX = (value: boolean) => value ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faXmark} />

  return <Table
  onRow={(row) => {
    if (!row.isApproved) {
      return { style: { color: grey[1], fontStyle: 'italic' } }
    }
    return {}
  }}
  columns={[
    { title: 'Name', dataIndex: 'name' },
    { title: 'Pricing Type', render: (record: WorkareaGroupInvoiceSummary) => <PricingTypeDisplay pricingType={record.pricingType} /> },
    { title: 'Approved', align: 'center', render: (record: WorkareaGroupInvoiceSummary) => renderCheckOrX(record.isApproved) },
    { title: 'Completed Visits', align: 'right', dataIndex: 'completedVisits' },
    { title: 'Estimated Hours', align: 'right', render: (record: WorkareaGroupInvoiceSummary) => record.estimatedHours.toFixed(2) },
    { title: 'Actual Hours', align: 'right', render: (record: WorkareaGroupInvoiceSummary) => record.actualHours.toFixed(2) },
    { title: 'Estimated Price', align: 'right', render: (record: WorkareaGroupInvoiceSummary) => centsToDollarsDisplay(record.estimatedPrice) },
    { title: 'Actual Price', align: 'right', render: (record: WorkareaGroupInvoiceSummary) => centsToDollarsDisplay(record.actualPrice) },
    { title: 'Tax', align: 'right', render: (record: WorkareaGroupInvoiceSummary) => renderCheckOrX(record.showTaxInFinalPrice) },
    { title: 'Invoiced', align: 'right', render: (record: WorkareaGroupInvoiceSummary) => centsToDollarsDisplay(record.invoicedAmount) },
    { title: 'Billable', align: 'right', render: (record: WorkareaGroupInvoiceSummary) => centsToDollarsDisplay(record.billableAmount) },
  ]}
  dataSource={groupTotals}
  rowKey={x => x.id}
  footer={() => <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '1.2em' }}>Total Billable: {centsToDollarsDisplay(invoiceTotals.totalBillable)} </div>}
  pagination={{
    pageSize: 50,
    hideOnSinglePage: true,
  }}
  size="small"
/>
}

export default WorkareaTotals
